import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rec-fill",
  "use": "icon-rec-fill-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-rec-fill\">\n   \n        <rect id=\"icon-rec-fill_Rectangle\" x=\"12\" y=\"12\" width=\"136\" height=\"136\" rx=\"9\" />\n   \n</symbol>"
});
var result = sprite.add(symbol);
export default symbol